import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const joinHouseList = (payload) => api.post("/house-list", payload).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const rsvpEvent = (payload) => api.post("/events/rsvp", payload).then((r) => r.data);
export const fetchHouseListCount = () => api.get("/house-list/count").then((r) => r.data);
export const joinHouseAlerts = (payload) => api.post("/house-alerts", payload).then((r) => r.data);
export const submitReserveOrder = (payload) => api.post("/reserve/order", payload).then((r) => r.data);
export const fetchNotificationSettings = () => api.get("/admin/notification-settings").then((r) => r.data);
